export default __webpack_public_path__ + "static/media/logo-mobile.695f6b68.svg";